import { atom } from 'jotai'
import { selectedParcel } from 'src/v2/state/owner-reveal/sidebar'
import { zoningByCoordinates } from 'src/v2/state/owner-reveal/zoning'

export const parcelZoning = atom(async (get) => {
  const parcel = await get(selectedParcel)
  const position = parcel?.point?.geometry?.coordinates
  if (!position) {
    return undefined
  }

  const data = await get(zoningByCoordinates({ lat: position[1], lng: position[0] }))
  return data
})
